<template>
    <div class="view view__event_show">
        <template v-if="allow">
            <event-show/>
        </template>
    </div>
</template>

<script>
import EventShow from '@/components/ebs/events/show/EventShow'
import { User } from '@/User'

export default {
  components: { EventShow },
  name: 'view-event-show',
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    routeEventId () {
      return this.$route.params.id
    },
    //
    eventStatus () {
      return this.$store.getters.getEventStatus
    },
    //
    allow () {
      return !(this.eventStatus === 'draft' && this.user.isOnlyLearner())
    }
  },
  methods: {
    clearEvent () {
      this.$store.dispatch('clearEvent')
    },
    getEvent () {
      const eventID = this.$route.params.id

      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('getEventSummary', eventID).then(response => {
        if (!this.allow) {
          this.$router.push({ name: '404' })
        }
      }).finally(() => {
        this.$eventBus.$emit('stop-loading')
      })
    }
  },
  created () {
    this.clearEvent()
    this.getEvent()
  }
}
</script>
